import { render, staticRenderFns } from "./TeamDetail.vue?vue&type=template&id=2de0be55&scoped=true&"
import script from "./TeamDetail.vue?vue&type=script&lang=js&"
export * from "./TeamDetail.vue?vue&type=script&lang=js&"
import style0 from "./TeamDetail.vue?vue&type=style&index=0&id=2de0be55&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de0be55",
  null
  
)

export default component.exports